export default __webpack_public_path__ + "static/media/additionalcharges.0777d80d.svg";